// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__1kdo0","inputSuccess":"FieldCurrencyInput_inputSuccess__380Aw","inputError":"FieldCurrencyInput_inputError__3Z-D-"};